<div class="content-header" [ngClass]="{'sign-in-mini' : keyboardOpen}">
  <ng-content></ng-content>
  <div class="divider"></div>
</div>
